import { render, staticRenderFns } from "./equipment-maintenance.vue?vue&type=template&id=2f4f0c28&"
import script from "./equipment-maintenance.vue?vue&type=script&lang=js&"
export * from "./equipment-maintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports